import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { usePlanStore } from "../../store/usePlanStore";
import { useAcceptJs } from "react-acceptjs";
import axiosInstance from "../../api/axiosInstance";
import { useUserStore } from "../../store/useUserStore";
import useAuthStore from "../../store/useAuthStore";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useNavigate } from "react-router-dom";
import payment_logo from '../../assets/images/payment-logo.png';
import visa_icon from '../../assets/images/visa_icon.png';
import master_icon from '../../assets/images/master_icon.png';




const MySwal = withReactContent(Swal);
// live keys
const authData = {
  apiLoginID: '538PmNJ6dFAU',
  clientKey: '4ftQ4aN9nz3nB6TNtxg63W8XkF53BHm9K3r5XSekruu9DKSGC6367a73N8Ew4HfU',
};
// test keys
// const authData = {
//   apiLoginID: '7v6VyH2J',
//   clientKey: '7dsdk6j495Ty2MuFRFjh4UDeKzg7Sp4YLuKNMmCH36Jky4pbCfpFbZLQn94Q5kyW',
// };

interface BasicCardInfo {
  cardNumber: string;
  cardCode: string;
  month: string;
  year: string;
  name: string;
  addressline1: string;
  addressline2: string;
  city: string;
  state: string;
  zipcode: string;
  cardType: string;
}

interface SubscriptionProps {
  savedCards: any[];
  planId: number;
  type: Type;
  colum?: string;
  paymentDetails: any;
  settings:any
  handleClose: () => void;
}
type Type = 'signup' | 'add_new_card' | 'edit';

const SubscriptionInfo: React.FC<SubscriptionProps> = ({ savedCards, planId, colum='col-md-12', type,settings, handleClose }) => {
  const { planDetail, getSinglePlans } = usePlanStore();
 

  const authStore = useAuthStore.getState();
  const userId = authStore.user?.id;
  const { user, getUserDetails } = useUserStore();
  const navigate = useNavigate();

  const { dispatchData } = useAcceptJs({ environment: 'PRODUCTION', authData });  //PRODUCTION  //SANDBOX
  const [cardData, setCardData] = useState<BasicCardInfo>({
    cardNumber: '',
    month: '',
    year: '',
    cardCode: '',
    name: '',
    addressline1: '',
    addressline2: '',
    city: '',
    state: '',
    zipcode: '',
    cardType: '',
  });

  const [load, setLoad] = useState(false);
  
  const [name_error, setNameError] = React.useState('');
  const [addressline1_error, setAdressline1Error] = React.useState('');
  const [state_error, setStateError] = React.useState('');
  const [city_error, setCityError] = React.useState('');
  const [zipcode_error, setZipcodeError] = React.useState('');
  const [card_error, setCardError] = React.useState('');
  const [month_error, setMonthError] = React.useState('');
  const [year_error, setYearError] = React.useState('');
  const [cvc_error, setCVCError] = React.useState('');
  const [payerror, setpayerror] = React.useState('');
  const [selectedCardId, setSelectedCardId] = useState<string | null>(null);
  const [showNewCardForm, setShowNewCardForm] = useState(type== 'add_new_card' ? true: false);
  const [errors, setErrors] = useState({
    name: '',
    addressline1: '',
    state: '',
    city: '',
    zipcode: '',
    card: '',
    month: '',
    year: '',
    cvc: '',
    payment: ''
  });

  useEffect(() => {
    getSinglePlans(planId);
    getUserDetails(parseInt(userId));
  }, [planId, userId]);

  const validatefields = (e: any) => {
    e.preventDefault();
    const isValid: any = [];
    if (cardData.name == '') {
      setNameError('This field is required!')
      console.log(cardData.name);
      isValid.push(1);
    } else {
      setNameError('')
    }
    if (cardData.addressline1 == '') {


      setAdressline1Error('This field is required')
      isValid.push(1);
    } else {
      setAdressline1Error('')
    }

    if (cardData.city == '') {
      setCityError('This field is required')
      isValid.push(1);
    } else {
      setCityError('')
    }
    if (cardData.state == '') {
      setStateError('This field is required')
      isValid.push(1);
    } else {
      setStateError('')
    }
    if (cardData.zipcode == '') {
      setZipcodeError('This field is required')
      isValid.push(1);
    } else {
      setZipcodeError('')
    }
    if (cardData.cardNumber == '') {
      setCardError('This field is required')
      isValid.push(1);
    } else {
      setCardError('')
    }
    if (cardData.month == '') {
      setMonthError('This field is required')
      isValid.push(1);
    } else {
      setMonthError('')
    }
    if (cardData.year == '') {
      setYearError('This field is required')
      isValid.push(1);
    } else {
      setYearError('')
    }
    if (cardData.cardCode == '') {
      setCVCError('This field is required')
      isValid.push(1);
    } else {
      setCVCError('')
    }

    if (isValid.length == 0) {
      handleSubmit(e)
    }
  }
  
  const stateAbbreviations = [
    { short: "AL", full: "Alabama" },
    { short: "AK", full: "Alaska" },
    { short: "AZ", full: "Arizona" },
    { short: "AR", full: "Arkansas" },
    { short: "CA", full: "California" },
    { short: "CO", full: "Colorado" },
    { short: "CT", full: "Connecticut" },
    { short: "DE", full: "Delaware" },
    { short: "FL", full: "Florida" },
    { short: "GA", full: "Georgia" },
    { short: "HI", full: "Hawaii" },
    { short: "ID", full: "Idaho" },
    { short: "IL", full: "Illinois" },
    { short: "IN", full: "Indiana" },
    { short: "IA", full: "Iowa" },
    { short: "KS", full: "Kansas" },
    { short: "KY", full: "Kentucky" },
    { short: "LA", full: "Louisiana" },
    { short: "ME", full: "Maine" },
    { short: "MD", full: "Maryland" },
    { short: "MA", full: "Massachusetts" },
    { short: "MI", full: "Michigan" },
    { short: "MN", full: "Minnesota" },
    { short: "MS", full: "Mississippi" },
    { short: "MO", full: "Missouri" },
    { short: "MT", full: "Montana" },
    { short: "NE", full: "Nebraska" },
    { short: "NV", full: "Nevada" },
    { short: "NH", full: "New Hampshire" },
    { short: "NJ", full: "New Jersey" },
    { short: "NM", full: "New Mexico" },
    { short: "NY", full: "New York" },
    { short: "NC", full: "North Carolina" },
    { short: "ND", full: "North Dakota" },
    { short: "OH", full: "Ohio" },
    { short: "OK", full: "Oklahoma" },
    { short: "OR", full: "Oregon" },
    { short: "PA", full: "Pennsylvania" },
    { short: "RI", full: "Rhode Island" },
    { short: "SC", full: "South Carolina" },
    { short: "SD", full: "South Dakota" },
    { short: "TN", full: "Tennessee" },
    { short: "TX", full: "Texas" },
    { short: "UT", full: "Utah" },
    { short: "VT", full: "Vermont" },
    { short: "VA", full: "Virginia" },
    { short: "WA", full: "Washington" },
    { short: "WV", full: "West Virginia" },
    { short: "WI", full: "Wisconsin" },
    { short: "WY", full: "Wyoming" }
  ];
  const paymentSuccessPopup = (onOk: () => void) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Payment Successful</h3>
          <p>Your payment has been processed successfully.</p>
          <div className="d-flex justify-content-center">
            <button className="btn btn-success" onClick={() => {
              onOk();
              MySwal.close();
            }}>
              OK
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };

  const cardAddSuccessPopup = (onOk: () => void) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Card Added Successfully</h3>
          <p>Your card has been added to your account.</p>
          <div className="d-flex justify-content-center">
            <button
              className="btn btn-success"
              onClick={() => {
                onOk();
                MySwal.close();
              }}
            >
              OK
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };
  
  const handlePaymentWithSavedCard = async () => {
    if (!selectedCardId) {
      setErrors({...errors, payment: 'Please select a card first'});
      return;
    }

    setLoad(true);
    try {
      const data = {
        name: user.first_name,
        email: user.email,
        phone: user.number,
        user_id: userId,
        selected_plan: planId,
        amount: planDetail?.amount ?? 0,
        interval: planDetail?.interval ?? '',
        interval_count: planDetail?.interval_count ?? 0,
        id: planDetail?.id ?? '',
        title: planDetail?.title ?? ''
      };

      const response = await axiosInstance.post('/authrizepayment', {
        from: 'with_saved_card',
        cardId: selectedCardId,
        plan: data
      });

      if (response.status === 200) {
        paymentSuccessPopup(() => {
          if (type === 'signup') {
            navigate('/dashboard');
          } else {
            handleClose();
            getUserDetails(parseInt(userId));
          }
        });
      }
    } catch (error:any) {
      console.log('Received error:', error.response.data);
      setpayerror(error.response.data);
      setErrors({...errors, payment: 'Payment failed. Please try again.'});
    } finally {
      setLoad(false);
    }
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    setCardError('')
    setMonthError('')
    setYearError('')
    setCVCError('')
    console.log('dispatchData:');
    setLoad(true);

    try {
      const token = await dispatchData({ cardData });
      const data = {
        name: user.first_name,
        email: user.email,
        phone: user.number,
        user_id: userId,
        selected_plan: planId,
        amount: planDetail?.amount ?? 0,
        interval: planDetail?.interval ?? '',
        interval_count: planDetail?.interval_count ?? 0,
        id: planDetail?.id ?? '',
        title: planDetail?.title ?? ''
      };

      const response = await axiosInstance.post('/authrizepayment', {
        from: type,
        creditCard: token.opaqueData,
        plan: data,
        cardData: cardData
      });

      if (response.status === 200) {
        if (type === 'signup') {
          paymentSuccessPopup(() => navigate('/dashboard'));
        } else {
          handleClose();
          cardAddSuccessPopup(() => getUserDetails(parseInt(userId)));
        }
      }
    } catch (error:any) {
      // Handle error
      setLoad(false);
      console.log('Received error:', error);
      console.log('Received error:', error.response.data);
      setpayerror(error.response.data);

      if (error.messages.message.length > 0) {
        error.messages.message.map(function (item: any) {
          console.log('test', item.code);
          if (item.code == 'E_WC_05') {
            console.log('test', item.text);
            setCardError(item.text)
          }
          if (item.code == 'E_WC_06') {
            setMonthError(item.text)
          }
          if (item.code == 'E_WC_07' || item.code == 'E_WC_08') {
            setYearError(item.text)
          }
          if (item.code == 'E_WC_15') {
            setCVCError(item.text)
          }
          if (item.code == 'E_WC_02') {
            setNameError(item.text)
          }

        })
      }
    } finally {
      setLoad(false);
    }
  };

  function getCardType(cardNumber: string): string {
    const number = cardNumber.replace(/\D/g, '');
    const firstTwo = parseInt(number.slice(0, 2), 10);
    const firstSix = parseInt(number.slice(0, 6), 10);
  
    if (/^4/.test(number)) return 'Visa';
    if ((firstTwo >= 51 && firstTwo <= 55) || (firstSix >= 222100 && firstSix <= 272099)) return 'MasterCard';
    if (/^3[47]/.test(number)) return 'American Express';
    if (/^6(?:011|5|4[4-9])/.test(number)) return 'Discover';
    return 'Unknown';
  }

  const getButtonLabel = (type: Type, loading: boolean) => {
    if (loading) return "Processing...";
    switch (type) {
      case "signup":
        return "Subscribe";
      case "add_new_card":
      case "edit":
        return "Save Changes";
      default:
        return "Submit";
    }
  };

  // ... (keep all your existing helper functions like paymentSuccessPopup, cardAddSuccessPopup, getCardType, etc.)

  const hasSavedCards = savedCards && savedCards.length > 0;
  const showCardSelection = hasSavedCards && !showNewCardForm; //&& type !== 'signup';

  return (
          <>
                <form className="container" onSubmit={validatefields}>
                        <div className="card p-lg-4 p-3 border rounded-4">
                                {type=='add_new_card'? 
                                <div className="border-bottom pb-3 mb-3 d-flex w-100 align-items-center gap-3">
                                            <h4 className="mb-0">Add Payment</h4>
                                            <button className="btn_close_cross_btn ms-auto " onClick={handleClose}>
                                                <i className="fa-solid fa-xmark"></i>
                                            </button>
                                        </div>
                                        :
                                <div className="accountSettingTitle border-bottom mb-4 pb-2" onClick={handleClose}>
                                    <h4><i className="fa-solid fa-arrow-left me-2"></i> Subscription Info</h4>
                                </div>
                                }
                                <div className="row gx-lg-5">
                                {showCardSelection ? (
                              
                                
                               
                                <div className="col-lg-7">
                                    <div className="card p-lg-4 p-3 border rounded-4 mb-3">
                                        <div className="accountSettingTitle border-bottom mb-4">
                                            <h4>Payment Method</h4>
                                            <p>Update your payment method</p>
                                        </div>
                                        <div className="account_subscription_lists">
                                        {savedCards.map((card: any) => (
                                           <div key={card.card_id} 
                                           className={`account_subscription_plan form-check ${selectedCardId === card.card_id ? 'border-primary' : ''}`}
                                           onClick={() => setSelectedCardId(card.card_id)}>
                                            {card.status && (<div className="account_subscription_plan_badge">
                                               Default card
                                           </div>)}
                                           

                                           <label className="form-check-label w-100 mt-4" htmlFor="paymentCard1">
                                               <input className=" form-check-input" type="radio" name="paymentCard"
                                                   id="paymentCard1" checked={selectedCardId === card.card_id}
                                                   onChange={() => setSelectedCardId(card.card_id)} />
                                               <div
                                                   className="d-flex align-items-center justify-content-between mb-3 ">
                                                   <div className="ps-4">
                                                       <h5 className="mb-2">{card.card_name}</h5>
                                                       <p className="mb-0">{card.card_number ?? '------'}</p>
                                                   </div>
                                                   <div className="">
                                                   {card.card_type=='Visa'? 
                                                            <img src={visa_icon} alt="" />
                                                            :  
                                                            <img src={master_icon} alt="" />
                                                          }
                                                      
                                                   </div>
                                               </div>
                                               

                                           </label>
                                       </div>
                                           
                                          ))}

                                          <div className="d-flex justify-content-between mt-3">
                                                      
                                                      <a href="#" className="text-decoration-none font400  text-primary" onClick={() => setShowNewCardForm(true)}><i
                                                        className="fa-solid fa-plus me-2"></i>
                                                        Use a different card</a>
                                                      
                                                    </div>


                                        </div>
                                    </div>
                                </div>
                               
                            

                               
                               
                                ) : (
                                  <>
                              
                                    <div className={type == 'add_new_card'? 'col-md-12' : 'col-md-7'}>
                                        <div className="mb-3">
                                            <label className="form-label mb-2 font600 font16">Name on Card</label>
                                            <input className="form-control" type="text"
                                            onChange={(e) => setCardData({ ...cardData, name: e.target.value })}
                                            placeholder="Type here..." />
                                            <span className="text-danger muierror">{name_error}</span>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label mb-2 font600 font16">Card Number</label>
                                            <input className="form-control" type="text"
                                            value={cardData.cardNumber}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              const cardType = getCardType(value);
                                              setCardData({ ...cardData, cardNumber: value, cardType })
                                            }}
                                            placeholder="Type here..." />
                                            <span className="text-danger muierror">{card_error}</span>
                                        </div>
                                        <div className="row">
                                              {/* Expiration Month */}
                                              <div className={type === 'add_new_card' ? colum : 'col-md-4'}>
                                                <div className="mb-3">
                                                  <label className="form-label mb-2 font600 font16">Expiration Month</label>
                                                  <input
                                                      className="form-control"
                                                          type="text"
                                                          maxLength={2}
                                                          pattern="\d*"
                                                          inputMode="numeric"
                                                          value={cardData.month}
                                                          onChange={(e) => {
                                                            let value = e.target.value.replace(/\D/g, '');

                                                            // Ensure it's only 1-2 digits
                                                            if (value.length === 1) {
                                                              if (parseInt(value) > 1) {
                                                                value = '0' + value; // Auto prepend 0 (e.g., 3 → 03)
                                                              }
                                                            } else if (value.length === 2) {
                                                              if (parseInt(value) < 1) value = '01';
                                                              if (parseInt(value) > 12) value = '12';
                                                            }

                                                            setCardData({ ...cardData, month: value });
                                                          }}
                                                          placeholder="MM"
                                                        />
                                                  <span className="text-danger muierror">{month_error}</span>
                                                </div>
                                              </div>

                                              {/* Expiration Year */}
                                              <div className={type === 'add_new_card' ? colum : 'col-md-4'}>
                                                <div className="mb-3">
                                                  <label className="form-label mb-2 font600 font16">Expiration Year</label>
                                                  <input
                                                    className="form-control"
                                                    type="text"
                                                    maxLength={2}
                                                    pattern="\d*"
                                                    inputMode="numeric"
                                                    value={cardData.year}
                                                    onChange={(e) => {
                                                      const value = e.target.value.replace(/\D/g, '').slice(0, 2);
                                                      setCardData({ ...cardData, year: value });
                                                    }}
                                                    placeholder="YY"
                                                  />
                                                  <span className="text-danger muierror">{year_error}</span>
                                                </div>
                                              </div>

                                              {/* CVV */}
                                              <div className={type === 'add_new_card' ? colum : 'col-md-4'}>
                                                <div className="mb-3">
                                                  <label className="form-label mb-2 font600 font16">CVV</label>
                                                  <input
                                                    className="form-control"
                                                    type="text"
                                                    maxLength={4}
                                                    pattern="\d*"
                                                    inputMode="numeric"
                                                    value={cardData.cardCode}
                                                    onChange={(e) => {
                                                      const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                                                      setCardData({ ...cardData, cardCode: value });
                                                    }}
                                                    placeholder="3 or 4 digits"
                                                  />
                                                  <span className="text-danger muierror">{cvc_error}</span>
                                                </div>
                                              </div>
                                              
                                            <div className="row">
                                              <div className="col-sm-12">
                                                <label htmlFor="name">Billing Adresss <span className='text-danger'>*</span></label>
                                                <div className="row">
                                                  <div className="col-sm-12 mb-2">
                                                    <input autoComplete="new-password" className="form-control" onChange={(event) =>
                                                      setCardData({ ...cardData, addressline1: event.target.value })
                                                    } id="address_line1" type="text" placeholder="Address line 1" />
                                                    <span className='text-danger muierror'>{addressline1_error}</span>
                                                  </div>
                                                  <div className="col-sm-12 mb-2">
                                                    <input autoComplete="new-password" className="form-control" onChange={(event) =>
                                                      setCardData({ ...cardData, addressline2: event.target.value })} id="address_line_2" type="text" placeholder="Address line 2" />

                                                  </div>
                                                  <div className={type== 'add_new_card' ? `${colum} mb-2` : 'col-sm-4 mb-2'}>
                                                    <input autoComplete="new-password" className="form-control" onChange={(event) =>
                                                      setCardData({ ...cardData, city: event.target.value })} id="City" type="text" placeholder="City" />
                                                    <span className='text-danger muierror'>{city_error}</span>
                                                  </div>
                                                  <div className={type== 'add_new_card' ? `${colum} mb-2` : 'col-sm-4 mb-2'}>
                                                    <select autoComplete="new-password" className='form-control' onChange={(event) =>
                                                      setCardData({ ...cardData, state: event.target.value })}>
                                                      <option>Select State</option>
                                                      {stateAbbreviations.map((val: any) => (
                                                        <option value={val.short}>{val.full}</option>
                                                      ))}
                                                    </select>
                                                    <span className='text-danger muierror'>{state_error}</span>
                                                  </div>
                                                  <div className={type== 'add_new_card' ? `${colum} mb-2` : 'col-sm-4 mb-2'}>
                                                    <input autoComplete="new-password" className="form-control" onChange={(event) =>
                                                      setCardData({ ...cardData, zipcode: event.target.value })} id="zipcode" type="number" placeholder="zip code" />
                                                    <span className='text-danger muierror'>{zipcode_error}</span>
                                                  </div>
                                                </div>
                                            </div>
                                          </div>
                                            <div className="col-md-12">
                                                <img src={payment_logo} alt="" />
                                            </div>


                                            {type != 'add_new_card'?
                                            <div className="col-md-12">
                                                <div className="border-top my-3 pt-3 act_setting_checkbox ">
                                                    <div className="form-check">
                                                        <input className="form-check-input mt-1" type="checkbox" value=""
                                                            id="checkDefault" />
                                                        <label className="form-check-label" htmlFor="checkDefault">
                                                            Your subscription will auto-renew for the same price
                                                            (${(
                                                            Number(planDetail?.amount || 0) + 
                                                            Number(settings?.sale_tax || 0)
                                                          ).toFixed(2)}) and package length until you cancel, at any
                                                            time,
                                                            via Account Settings.
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>
                                            :  
                                            <>
                                             <button className="btn btn-outline-primary w-100 mt-4" type="submit"  disabled={load}>
                                             {getButtonLabel(type, load)}
                                            </button>
                                            </>
                                           
                                            }


                                        </div>
                                    </div>
                                   
                                


                                 
                                

                                    {hasSavedCards && type != 'signup' && type != 'add_new_card' && (
                                    <button 
                                      type="button"
                                      className="btn btn-link w-100 mt-2"
                                      onClick={() => setShowNewCardForm(false)}
                                    >
                                      Use a saved card instead
                                    </button>
                                  )}
                                </>
                                )}

                                    {type == 'signup' ?
                                    <div className="col-md-5">
                                        <div className="position-relative p-3 border rounded-4">
                                            <div className="">
                                                <h4 className="mb-3">Review your subscription</h4>
                                                <div className="d-flex justify-content-between mb-2">
                                                    <p className="font16 font600 mb-0">Premium Plan</p>
                                                    <p className="font16 font600 mb-0">${planDetail?.amount}</p>
                                                </div>
                                                {settings?.sale_tax >0 ?
                                                <div className="d-flex justify-content-between mb-2">
                                                    <p className="font16 font600 mb-0">Sales Tax</p>
                                                    <p className="font16 font600 mb-0">${settings.sale_tax}</p>
                                                </div>
                                                : ''}
                                                <div className="d-flex justify-content-between mt-3 border-top pt-3">
                                                    <p className="font16 font600 mb-0">Total</p>
                                                    <p className="font16 font600 mb-0 text-primary"> ${(
                                                            Number(planDetail?.amount || 0) + 
                                                            Number(settings?.sale_tax || 0)
                                                          ).toFixed(2)}</p>
                                                </div>
                                                {payerror && <p className="text-danger mt-2">{payerror}</p>}
                                            </div>
                                        </div>
                                        <div className="text-center mt-2 mt-lg-4">
                                          {!showCardSelection ? 
                                            <button className="btn btn-primary px-lg-5 " type="submit" >  {load ? "Processing..." : type === 'signup' ? "Subscribe" : "Save Changes"}</button>
                                        :   <button 
                                        type="button" 
                                        className="btn btn-primary"
                                        onClick={handlePaymentWithSavedCard}
                                        disabled={!selectedCardId || load}
                                      >
                                        {load ? "Processing..." : "Pay with Selected Card"}
                                      </button>}
                                          
                                          
                                        </div>
                                    </div>
                                    :
                                       ''         
                                    }
                                    </div>
                            </div>
                       </form>


    {/* <form className="container mt-5" onSubmit={validatefields}>
      <div className="row shadow rounded p-4 bg-white">
        <div className={type === 'signup' ? "col-md-8 border-end" : "col-md-12 border-end"}>
          <button type="button" onClick={handleClose} className="btn-close ms-auto" aria-label="Close"></button>
          <h5 className="mb-4">Subscription Info</h5>

          {showCardSelection ? (
            <>
              <div className="mb-4">
                <h6>Select a saved card</h6>
                {savedCards.map((card: any) => (
                  <div 
                    key={card.card_id} 
                    className={`border rounded p-3 mb-2 cursor-pointer ${selectedCardId === card.card_id ? 'border-primary' : ''}`}
                    onClick={() => setSelectedCardId(card.card_id)}
                  >
                    <div className="d-flex align-items-center">
                      <input
                        type="radio"
                        name="savedCard"
                        checked={selectedCardId === card.card_id}
                        onChange={() => setSelectedCardId(card.card_id)}
                        className="me-3"
                      />
                      <div>
                      <div className="col-md-4">
                            <strong>{card.name}</strong>
                             <div className="text-muted">{card.card_number ?? '------'}</div>
                              {card.status && (<span className="badge bg-primary mt-1">Default card</span>)}
                                            </div>
                        
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex justify-content-between mt-3">
                <button 
                  type="button" 
                  className="btn btn-primary"
                  onClick={handlePaymentWithSavedCard}
                  disabled={!selectedCardId || load}
                >
                  {load ? "Processing..." : "Pay with Selected Card"}
                </button>
                <button 
                  type="button"
                  className="btn btn-link text-danger"
                  onClick={() => setShowNewCardForm(true)}
                >
                  Use a different card
                </button>
              </div>
            </>
          ) : (
            <>
               <div className="mb-3">
                <label className="form-label">Name on Card</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setCardData({ ...cardData, name: e.target.value })}
                  placeholder="Type here..."
                />
                <span className="text-danger muierror">{name_error}</span>
              </div>

              <div className="mb-3">
                <label className="form-label">Card Number</label>
                <input
                  type="text"
                  value={cardData.cardNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    const cardType = getCardType(value);
                    setCardData({ ...cardData, cardNumber: value, cardType })
                  }}
                  className="form-control"
                  placeholder="Type here..."
                />
                <span className="text-danger muierror">{card_error}</span>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <label className="form-label">Expiration Month</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="MM"
                    onChange={(e) => setCardData({ ...cardData, month: e.target.value })}
                  />
                  <span className="text-danger muierror">{month_error}</span>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Expiration Year</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="YY"
                    onChange={(e) => setCardData({ ...cardData, year: e.target.value })}
                  />
                  <span className="text-danger muierror">{year_error}</span>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">CVV</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="3 digit"
                  onChange={(e) => setCardData({ ...cardData, cardCode: e.target.value })}
                />
                <span className="text-danger muierror">{cvc_error}</span>
              </div>
              <div className="row">
                  <div className="col-sm-12">
                    <label htmlFor="name">Billing Adresss <span className='text-danger'>*</span></label>
                    <div className="row">
                      <div className="col-sm-12 mb-2">
                        <input autoComplete="new-password" className="form-control" onChange={(event) =>
                          setCardData({ ...cardData, addressline1: event.target.value })
                        } id="address_line1" type="text" placeholder="Address line 1" />
                        <span className='text-danger muierror'>{addressline1_error}</span>
                      </div>
                      <div className="col-sm-12 mb-2">
                        <input autoComplete="new-password" className="form-control" onChange={(event) =>
                          setCardData({ ...cardData, addressline2: event.target.value })} id="address_line_2" type="text" placeholder="Address line 2" />

                      </div>
                      <div className="col-sm-4 mb-2">
                        <input autoComplete="new-password" className="form-control" onChange={(event) =>
                          setCardData({ ...cardData, city: event.target.value })} id="City" type="text" placeholder="City" />
                        <span className='text-danger muierror'>{city_error}</span>
                      </div>
                      <div className="col-sm-4 mb-2">
                        <select autoComplete="new-password" className='form-control' onChange={(event) =>
                          setCardData({ ...cardData, state: event.target.value })}>
                          <option>Select State</option>
                          {stateAbbreviations.map((val: any) => (
                            <option value={val.short}>{val.full}</option>
                          ))}
                        </select>
                        <span className='text-danger muierror'>{state_error}</span>
                      </div>
                      <div className="col-sm-4 mb-2">
                        <input autoComplete="new-password" className="form-control" onChange={(event) =>
                          setCardData({ ...cardData, zipcode: event.target.value })} id="zipcode" type="number" placeholder="zip code" />
                        <span className='text-danger muierror'>{zipcode_error}</span>
                      </div>
                    </div>
                </div>
              </div>

              <button type="submit" className="btn btn-danger w-100 mt-4">
                {load ? "Processing..." : type === 'signup' ? "Subscribe" : "Save Changes"}
              </button>
             

              {hasSavedCards && type !== 'signup' && (
                <button 
                  type="button"
                  className="btn btn-link w-100 mt-2"
                  onClick={() => setShowNewCardForm(false)}
                >
                  Use a saved card instead
                </button>
              )}
            </>
          )}
        </div>

        {type === 'signup' && (
          <div className="col-md-4 ps-4">
            <h6>Review your subscription</h6>
            <div className="d-flex justify-content-between mt-3">
              <span>Premium Plan</span>
              <span>${planDetail?.amount}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Sales Tax</span>
              <span>${settings.sale_tax}</span>
            </div>
            <hr />
            <div className="d-flex justify-content-between fw-bold">
              <span>Total</span>
              <span className="text-danger">
                ${(
                  Number(planDetail?.amount || 0) + 
                  Number(settings?.sale_tax || 0)
                ).toFixed(2)}
              </span>
            </div>
            {payerror && <p className="text-danger mt-2">{payerror}</p>}
          </div>
        )}
      </div>
    </form> */}
    </>
  );
};

export default SubscriptionInfo;